import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { IBreadcrumb } from "~/types/system";
import { useStore } from "~/hooks/useStore";
import RootStore from "~/store/RootStore";
import { useAppointmentSteps } from "~/hooks/useAppointmentSteps";
import ROUTES from "~/utils/routes";
import config from "~/config";

const useBreadcrumbs = () => {
  const { pathname } = useLocation();
  const [location, setLocation] = useState<IBreadcrumb | null>(null);
  const store: RootStore = useStore();
  const { currentStepIdx } = useAppointmentSteps();
  const { isMoscowRegion } = store.cityStore;

  // ========================================Effects-START=======================================
  useEffect(() => {
    let route;

    switch (pathname) {
      case ROUTES.LOGIN.PATHNAME:
        setLocation({
          to: config.seoPartUrl,
          title: "Вернуться к выбору медицинских учреждений",
          external: true,
        });
        break;
      case ROUTES.HOSPITALS.PATHNAME:
        route = isMoscowRegion ? ROUTES.DOCTORS : ROUTES.LOGIN;
        setLocation({
          to: route.PATHNAME,
          title: route.BREADCRUMB,
        });
        break;
      case ROUTES.SPECIALTIES.PATHNAME:
        route = isMoscowRegion ? ROUTES.LOGIN : ROUTES.HOSPITALS;
        setLocation({
          to: route.PATHNAME,
          title: route.BREADCRUMB,
        });
        break;
      case ROUTES.DOCTORS.PATHNAME:
        setLocation({
          to: ROUTES.SPECIALTIES.PATHNAME,
          title: ROUTES.SPECIALTIES.BREADCRUMB,
        });
        break;
      case ROUTES.DATES.PATHNAME:
        route = isMoscowRegion ? ROUTES.HOSPITALS : ROUTES.DOCTORS;
        setLocation({
          to: route.PATHNAME,
          title: route.BREADCRUMB,
        });
        break;
      case ROUTES.JOURNAL.PATHNAME:
        {
          switch (currentStepIdx) {
            case 0:
              setLocation({
                to: isMoscowRegion
                  ? store.appointmentStepsStore.currentStepRoute
                  : ROUTES.HOSPITALS.PATHNAME,
                title: isMoscowRegion
                  ? "Вернуться назад"
                  : ROUTES.HOSPITALS.BREADCRUMB,
              });
              break;
            case 1:
              setLocation({
                to: isMoscowRegion
                  ? ROUTES.HOSPITALS.PATHNAME
                  : store.appointmentStepsStore.currentStepRoute,
                title: isMoscowRegion
                  ? ROUTES.HOSPITALS.BREADCRUMB
                  : "Вернуться назад",
              });
              break;
            case 2:
              setLocation({
                to: ROUTES.DATES.PATHNAME,
                title: ROUTES.DATES.BREADCRUMB,
              });
              break;
            default:
              break;
          }

          if (
            (isMoscowRegion && currentStepIdx === 1) ||
            (!isMoscowRegion && currentStepIdx === 0)
          ) {
            setLocation({
              to: ROUTES.HOSPITALS.PATHNAME,
              title: ROUTES.HOSPITALS.BREADCRUMB,
            });
          } else if (
            (isMoscowRegion && currentStepIdx === 0) ||
            (!isMoscowRegion && currentStepIdx === 1)
          ) {
            setLocation({
              to: store.appointmentStepsStore.currentStepRoute,
              title: "Вернуться назад",
            });
          } else if (currentStepIdx === 2) {
            setLocation({
              to: ROUTES.DATES.PATHNAME,
              title: ROUTES.DATES.BREADCRUMB,
            });
          }
        }
        break;
      default:
        setLocation(null);
    }
  }, [pathname, currentStepIdx, store.appointmentStepsStore, isMoscowRegion]);
  // ========================================Effects-END=======================================

  return location;
};

export default useBreadcrumbs;
